export const SerpEngines = {
    YandexDesktop: 0,
    YandexMobile: 1,
    GoogleDesktop: 4,
    GoogleMobile: 3,
    YandexSearchApiDesktop: 6,
    YandexSearchApiMobile: 5,
};

SerpEngines.YandexEngines = [
    SerpEngines.YandexDesktop,
    SerpEngines.YandexMobile,
    SerpEngines.YandexSearchApiDesktop,
    SerpEngines.YandexSearchApiMobile,
];

SerpEngines.GoogleEngines = [
    SerpEngines.GoogleDesktop,
    SerpEngines.GoogleMobile,
];

SerpEngines.Desktop = [
    SerpEngines.YandexDesktop,
    SerpEngines.YandexSearchApiDesktop,
    SerpEngines.GoogleDesktop,
];

SerpEngines.Mobile = [
    SerpEngines.YandexMobile,
    SerpEngines.YandexSearchApiMobile,
    SerpEngines.GoogleMobile,
];
